import { SaleType } from '@models/paymentStatement';

export type PartnerSaleTypeDisplay = 'class' | 'commerce' | 'special';

export interface PartnerSaleTypeProductLike {
  saleType?: string;
  marketSection?: 'last-chance' | 'hot-deal' | 'early-bird' | string;
}

const MARKET_SECTIONS = new Set(['last-chance', 'hot-deal', 'early-bird']);

export const PARTNER_SALE_TYPE_LABEL: Record<PartnerSaleTypeDisplay, string> = {
  class: '클래스',
  commerce: '커머스',
  special: '특가상품',
};

export const PARTNER_SALE_TYPE_FILTER_OPTIONS: { label: string; value: Exclude<SaleType, ''> }[] = [
  { label: '클래스', value: 'class' },
  { label: '커머스', value: 'commerce' },
  { label: '특가상품', value: 'special' },
];

export const ALL_PARTNER_SALE_TYPES: Exclude<SaleType, ''>[] = ['class', 'commerce', 'special'];

export function isSpecialMarketProduct(product?: PartnerSaleTypeProductLike | null): boolean {
  return !!product?.marketSection && MARKET_SECTIONS.has(product.marketSection);
}

export function resolvePartnerSaleTypeDisplay(product?: PartnerSaleTypeProductLike | null): PartnerSaleTypeDisplay {
  if (isSpecialMarketProduct(product)) {
    return 'special';
  }
  return product?.saleType === 'class' ? 'class' : 'commerce';
}

export function getPartnerSaleTypeLabel(product?: PartnerSaleTypeProductLike | null): string {
  return PARTNER_SALE_TYPE_LABEL[resolvePartnerSaleTypeDisplay(product)];
}

export function shouldShowBuyerPhone(product?: PartnerSaleTypeProductLike | null): boolean {
  const displayType = resolvePartnerSaleTypeDisplay(product);
  return displayType === 'commerce' || displayType === 'special';
}

export function getSaleTypeQueryParams(checkedSaleTypes: SaleType[]): {
  saleType?: SaleType;
  saleTypeCategories?: Exclude<SaleType, ''>[];
} {
  const selected = checkedSaleTypes.filter((saleType): saleType is Exclude<SaleType, ''> => saleType !== '');

  if (selected.length === 0 || selected.length === ALL_PARTNER_SALE_TYPES.length) {
    return { saleType: '', saleTypeCategories: undefined };
  }
  if (selected.length === 1) {
    return { saleType: selected[0], saleTypeCategories: undefined };
  }
  return { saleType: '', saleTypeCategories: selected };
}
